import React from "react";
import {
  Container,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  withStyles,
} from "@material-ui/core";

const styles = theme => ({
  loader: {
    color: "#1e5abb",
  },
  table: {
    marginTop: theme.spacing(2),
  },
});

const UserInfo = ({ user, classes }) => {
  if (!user.email)
    return (
      <Container>
        <Box textAlign="center">
          <CircularProgress className={classes.loader} />
        </Box>
      </Container>
    );

  const userInfo = {
    Email: user.email,
    Utworzono: user.createdAt,
  };
  return (
    <Container>
      <TableContainer component="paper">
        <Table className={classes.table}>
          <TableBody>
            {Object.entries(userInfo).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell>{key}</TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default withStyles(styles)(UserInfo);
